import React, { useEffect } from "react";
import TransactionComp from "../Components/Transaction/Transaction";
const Transaction = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <TransactionComp />;
};

export default Transaction;
